import { Routes, Route } from 'react-router-dom';
import Home from './pages/home/Index';
import './App.css';
import Cart from './pages/cart/Index';

function App() {
	return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/finalizarPedido" element={<Cart />} />
		</Routes>
	);
}

export default App;
